import styled from 'styled-components/macro'
import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'


export const DesktopContent = styled.div`
    width: 90%;
    max-width: var(--content-maxwidth);
    margin: 3rem auto 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    flex-direction: column;

    @media all and (max-width: 1024px) {
        display: none;
    }
`

export const Title = styled(motion.h2)`
    margin-bottom: 3rem;
    color: white;
`

export const CardsContainer = styled(motion.div)`
    width: 90%;
    display: flex;
    justify-content: space-around;
    align-items: center;

    @media all and (max-width: 650px) {
        display: none;
    }
`

//PROBAR CAMBIAR WIDTH Y FUENTES ASI
// font-size: calc(.2rem + .9vw);
//HASTA MOBILE QUE ES SWIPER
export const Card = styled(motion(Link))`
    width: 16rem;
    height: 26rem;
    border-radius: 15px;
    background: 
    linear-gradient(180deg, rgba(34, 39, 51, 0.56) 99.99%, rgba(196, 196, 196, 0) 100%) , 
        url(${({background}) => background});
    background-size: cover;
    background-repeat: no-repeat;
    background-color: white;
    padding: .5rem;
    display: flex;
    flex-direction: column;
    box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.55);

    @media all and (max-width: 1024px) {
        width: 100%;
    }
`

export const CardTitle = styled.h3`
    color: white;
    font-size: 2.5rem;
    border-bottom: 1px solid white;
    padding-bottom: .5rem;
    margin-bottom: 1rem;
`

export const Feature = styled.p`
    color: white;
    margin-bottom: 1rem;
`